import './SystemConfigKeyManagement.css';
import PlusIcon from '../../assets/icons/plus.svg?react';
import ChevronLeftIcon from '../../assets/icons/chevron-left.svg?react';
import DeleteIcon from '../../assets/icons/delete.svg?react';
import { useNavigate } from 'react-router-dom';
import { useMemo, useState } from 'react';
import { useSetUpList } from '../../hooks/queries/setUpQueries';
import SystemSetUpAppendModal from './components/SystemSetUpAppendModal';
import SystemSetUpConfirmModal from './components/SystemSetUpConfirmModal';

const SystemConfigKeyManagement = () => {
  const navigate = useNavigate();
  const { data: setUpData, refetch: refetchSetUpList } = useSetUpList();

  const [isAppendModalOpen, setIsAppendModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedGroupName, setSelectedGroupName] = useState(null);
  const [target, setTarget] = useState(null);
  const handleSelectGroupName = (groupName) => {
    setSelectedGroupName(groupName);
  }

  // Group 필드를 기준으로 Items를 그룹화
  const groupedData = useMemo(() => {
    if (!setUpData?.Items || !Array.isArray(setUpData.Items)) {
      return {};
    }

    return setUpData.Items.reduce((acc, item) => {
      const groupName = item.Group || '기타';
      if (!acc[groupName]) {
        acc[groupName] = [];
      }
      acc[groupName].push(item);
      return acc;
    }, {});
  }, [setUpData]);

  // 그룹화된 데이터의 키 배열 (그룹 이름들)
  const groupNames = useMemo(() => {
    return Object.keys(groupedData);
  }, [groupedData]);

  const onCloseAppendModal = () => {
    setIsAppendModalOpen(false);
    refetchSetUpList();
  }
  const onCloseDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setTarget(null);
  }
  return (
    <div className="system-config-key-management-container">
      <div className='flex flex-col gap-20'>
        <div className='flex justify-between'>
            <button 
              className="btn icon-btn flex align-center gap-2" 
              onClick={() => navigate(-1)}
            >
              <ChevronLeftIcon color="var(--gray-600)" />
              <h3 className="text-b2-700 text-gray-600">목록으로 돌아가기</h3>
            </button>
        </div>
        <div className='flex justify-between align-center'>
          <h2 className='text-h2 text-gray-700'>시스템 구성 키 관리</h2>
          <button className='btn big-btn btn-primary' onClick={() => setIsAppendModalOpen(true)}>
            <PlusIcon />
            시스템 구성 키 추가
          </button>
        </div>
        {/* 그룹화된 데이터 목록 */}
        <div className='system-config-key-management-group-container grid grid-cols-2 gap-5'>
          <div className='flex flex-col'>
            <div>
              <p className='text-b2-700 text-gray-600'>그룹</p>
            </div>
            <div className='flex flex-col'>
              {/* 그룹 목록 */}
              {groupNames.map((groupName) => (
                <div key={groupName} className={`system-config-key-management-group-name cursor-pointer ${selectedGroupName === groupName ? 'selected' : ''}`} onClick={() => handleSelectGroupName(groupName)}>
                  <p className='text-b2-400 text-gray-600'>{groupName}</p>
                </div>
              ))}
            </div>
          </div>
          <div className='flex flex-col'>
            <div>
              <p className='text-b2-700 text-gray-600'>키</p>
            </div>
            <div className='flex flex-col'>
              {/* 값 목록 */}
              {selectedGroupName ? (
                <div>
                  {groupedData[selectedGroupName]?.map((item) => (
                    <div key={item.Key} className='system-config-key-management-key'>
                      <p className='text-b2-700 text-gray-600'>{item.Key}</p>
                      <div className='flex align-center gap-2'>
                        {
                          !item.UnDeletable ?
                          <button className='btn icon-btn' onClick={() => {setIsDeleteModalOpen(true); setTarget(item); } }>
                            <DeleteIcon color='var(--error)'/>
                          </button>
                          :
                          <p className='text-c2-400 text-gray-600'>삭제불가</p>
                        }
                      </div>
                    </div>
                  ))}
                </div>
              ) : 
              
              <div className='text-center text-b2-700 text-gray-600 p-10'>그룹을 선택해주세요.</div>
              }
            </div>
          </div>
        </div>
      </div>
      {isAppendModalOpen && (
        <SystemSetUpAppendModal groupNames={groupNames} onClose={onCloseAppendModal} />
      )}
      {isDeleteModalOpen && (
        <SystemSetUpConfirmModal data={target} value={target.Value} onClose={onCloseDeleteModal} mode={'delete'}/>
      )}
    </div>
  );
};

export default SystemConfigKeyManagement;

